<template>
  <div>
    <v-container>
      <v-layout row wrap align-center>
        <v-flex md12 sm12 xs12 class>
          <v-select
            :items="types"
            outline
            placeholder="Custom/Pay"
            class="input-group--focused"
            v-model="newPackage.typee"></v-select>
        </v-flex>
        <v-flex xs12 v-if="newPackage.typee=='Custom'">
          <v-btn
            class="btnM mainBackG card-r no-shadow"
            type="submit"
            to="CustomVerification">Sign Up</v-btn>
        </v-flex>
        <v-flex xs12 v-if="newPackage.typee=='Pay'">
          <v-btn
            class="btnM mainBackG card-r no-shadow"
            type="submit"
            to="verification">Sigewcfewfdn Up</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  /* eslint-disable */
  export default {
    data: () => ({
      newPackage: {
        typee: "dsfdfd",
        user: {
        },
      },
      types: ['Pay', 'Free', 'After 3', 'After 5', 'Custom'],
    }),
  };
</script>





// WEBPACK FOOTER //
// src/components/test/test.vue